import { render, staticRenderFns } from "./PackageCard.vue?vue&type=template&id=854ea304&scoped=true&"
import script from "./PackageCard.vue?vue&type=script&lang=js&"
export * from "./PackageCard.vue?vue&type=script&lang=js&"
import style0 from "./PackageCard.vue?vue&type=style&index=0&id=854ea304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854ea304",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCardText,VImg,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('854ea304')) {
      api.createRecord('854ea304', component.options)
    } else {
      api.reload('854ea304', component.options)
    }
    module.hot.accept("./PackageCard.vue?vue&type=template&id=854ea304&scoped=true&", function () {
      api.rerender('854ea304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopInfo/components/TopUpPackage/components/PackageCard.vue"
export default component.exports